import { PageDefinition } from 'pages/pageDefinition'
import { matchPath } from 'react-router-dom'
import { WebAdminUser } from '../api'

// 2 minutes
const MAX_AGE_OF_API_DATA = 1000 * 60 * 2

export const removeUnauthorizedPages = (
  pages: PageDefinition[],
  user: WebAdminUser | null,
) => {
  return pages.filter((page) => page.canAccess(user))
}

export const doesPageMatchRoute = (
  pageRoute: string,
  location: string,
  caseSensitive: boolean = true,
) => {
  const match = matchPath({
    path: pageRoute,
    caseSensitive
  }, location)

  return match !== null
}

export const canViewAgencyPage = (user: WebAdminUser | null) => {
  if (user === null) return false

  return (
    (user.isSupport && user.customerAgencyId !== null) ||
    (!user.isSupport && user.isAdmin) ||
    (user.authorizedLicensedAgencies !== undefined && user.authorizedLicensedAgencies !== null && user.authorizedLicensedAgencies.length > 1)
  )
}

export const isAssisting = (user: WebAdminUser | null) => {
  if (
    !user ||
    !user.isAssisting ||
    !user.customerAgencyId ||
    !user.licensedAgencyId
  )
    return false

  return true
}

export const considerDataToBeStale = <TType extends {}>(
  data: TType[] | TType | null,
  lastApiReceiveAt: number | null,
) => {
  if (data === null) return true

  if (Array.isArray(data) && data.length === 0) return true

  if (lastApiReceiveAt === null) return true

  if (lastApiReceiveAt < Date.now() - MAX_AGE_OF_API_DATA) return true

  return false
}
